import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * A moved URL: replaces the location with `to`, keeping the query string (and a trailing
 * `*` splat when `to` ends with `/*`), so old links and bookmarks still land.
 */
export function Redirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  const params = useParams();
  const splat = params['*'];
  const path = to.endsWith('/*') ? `${to.slice(0, -2)}${splat ? `/${splat}` : ''}` : to;
  return <Navigate to={`${path}${search}${hash}`} replace />;
}
